/* TODO: t() */
import React, { useState } from 'react';
import { View, ScrollView, StyleSheet } from 'react-native';

import connectData, { ConnectedProps } from '../../support/connectData';

import { Page, TextInputSearch } from '../uiold';
import { themeColors } from '../uiold/Constants';

import VendorAccountList from '../VendorAccount/VendorAccountList';
import VendorAccountDetails from '../VendorAccount/VendorAccountDetails';

function VendorAccountsPage(props: FullProps) {
  let { vendorAccounts, account, user } = props;
  let [selectedID, setSelectedID] = useState<string | null | undefined>(null);
  let [filterText, setFilterText] = useState<string>('');

  let onItemClick = (id: string) => {
    setSelectedID(id);
  };

  let onClose = () => {
    setSelectedID(null);
  };

  let onSearchChange = (text: string) => {
    setFilterText(text);
  };

  if (!vendorAccounts || !account) {
    return (
      <Page isLoading={true}>
        <Page.Header title="Vendor Accounts" />
      </Page>
    );
  }
  let vendorAccount = vendorAccounts
    ? vendorAccounts.get(selectedID ?? '')
    : null;

  return (
    <Page>
      <Page.Header title="Vendor Accounts" />
      <View style={styles.panel}>
        <View style={styles.listPanel}>
          <View style={styles.searchControl}>
            <TextInputSearch
              autoFocus={true}
              value={filterText}
              onChangeText={onSearchChange}
            />
          </View>

          <ScrollView style={styles.listView}>
            <VendorAccountList
              vendorAccounts={vendorAccounts}
              selectedID={selectedID}
              filterText={filterText}
              onItemClick={onItemClick}
            />
          </ScrollView>
        </View>
        <View style={styles.detailPanel}>
          <VendorAccountDetails
            selectedID={selectedID}
            vendorAccount={vendorAccount}
            onClose={onClose}
            account={account}
            user={user}
          />
        </View>
      </View>
    </Page>
  );
}

let styles = StyleSheet.create({
  panel: {
    flex: 1,
    flexDirection: 'row',
  },
  listPanel: {
    width: '38%',
    marginRight: 20,
    borderRightColor: '#e7ebf0',
    borderRadius: 5,
    overflow: 'hidden',
  },
  searchControl: {
    paddingTop: 20,
    paddingBottom: 21,
    paddingHorizontal: 10,
    flexDirection: 'row',
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderColor: themeColors.borderGrey,
    backgroundColor: themeColors.white,
  },
  listView: {
    height: 0,
  },
  detailPanel: {
    flex: 1,
  },
});

const connector = connectData()(() => ({
  vendorAccounts: { dataStoreKey: 'vendorAccounts' },
  account: { dataStoreKey: 'account' },
  user: {
    dataStoreKey: 'user',
  },
}));
type FullProps = ConnectedProps<typeof connector>;
export default connector(VendorAccountsPage);
